import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { TranslateService } from '@ngx-translate/core';
import { Company } from 'app/models/company.model';
import { Device } from 'app/models/device.model';
import { CompanyService } from 'app/services/company.service';
import { DeviceService } from 'app/services/device.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { BaseFormComponent } from '../../base-form.component';
@Component({
    selector: 'app-device-edit',
    templateUrl: './device-edit.component.html',
    styleUrls: ['./device-edit.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class DeviceEditComponent extends BaseFormComponent implements OnInit {
    public companyId: number
    private _device: Device =
        {
            id: "00032",
            firmware: "00032",
            model: "2",
            periot: "15",
            shakeCount: "120",
            sonicActive: "1",
            sonicFilte: "10",
            sonicTolerans: "20",
            sonicMeasure: "15",
            msgTyr: "3",
            msgStanby: "35000",
            runType: "1",
            gpsRepeat: "20",
            gpsTime: "25",
            gpsPeriot: "8",
            shakeWait:"3",
            distanceTime:"5",
            distanceValue:"15",
            empty1:"0",
            empty2:"0",
            empty3:"0",
            batMin: "320",
            batGpMin: "380",
            batMultiplier: "1000",
            solarMultiplier: "1000",
            serialNumber: "DP0000000001",
            apn: "internet",
            hostRequestWeb: "http://212.154.111.45:10001",
            hostRequestEXT: "/custom_get_request",
            heatAlarm: "800",
            ssid: "Real",
            smsNumber: "5439024474",
            periotTimeOut: "20",
            updated: 1,
        };

    public advanced_setting = false;
    public basic_setting = true;
    public deviceList: Array<Device>
    public UDate: Date;
    public Time: Date;
    public selectedCompany: number;
    public companyList: Array<Company>

    public formGroup = new FormGroup({});
    public formPeriot=new FormControl('',[Validators.max(1440),Validators.min(15),Validators.required])
    public formShakeCount=new FormControl('',[Validators.max(200),Validators.min(0),Validators.required])
    public formSonicActive=new FormControl('',[Validators.max(1),Validators.min(0),Validators.required])
    public formSonicFilter=new FormControl('',[Validators.max(16),Validators.min(0),Validators.required])
    public formSonicTolerans=new FormControl('',[Validators.max(50),Validators.min(1),Validators.required])
    public formSonicMeasure=new FormControl('',[Validators.max(60),Validators.min(1),Validators.required])
    public formMessageRepeat=new FormControl('',[Validators.max(10),Validators.min(1),Validators.required])
    public formMsgStanby=new FormControl('',[Validators.max(65.535),Validators.min(0.001),Validators.required])
    public formRunType=new FormControl('',[Validators.max(4),Validators.min(1),Validators.required])
    public formGpsRepeat=new FormControl('',[Validators.max(100),Validators.min(1),Validators.required])
    public formGpsTime=new FormControl('',[Validators.max(40),Validators.min(1),Validators.required])
    public formGpsPeriot=new FormControl('',[Validators.max(200),Validators.min(1),Validators.required])
    public formBatMin=new FormControl('',[Validators.max(3.7),Validators.min(3.2),Validators.required])
    public formBatGpsMin=new FormControl('',[Validators.max(4.1),Validators.min(3.2),Validators.required])
    public formBatMultiple=new FormControl('',[Validators.max(9999),Validators.min(1),Validators.required])
    public formSolarMultiple=new FormControl('',[Validators.max(9999),Validators.min(1),Validators.required])
    public formPeriotTimeOut=new FormControl('',[Validators.max(60),Validators.min(10),Validators.required])
    public formShakeWait=new FormControl('',[Validators.max(100),Validators.min(1),Validators.required])
    public formDistanceTime=new FormControl('',[Validators.max(60),Validators.min(5),Validators.required])
    public formDistanceValue=new FormControl('',[Validators.max(70),Validators.min(10),Validators.required])
    public formHostRequestWeb=new FormControl('',[Validators.maxLength(45),Validators.required])
    public formHostRequestEXT=new FormControl('',[Validators.maxLength(45),Validators.required])
    public formHeatAlarm=new FormControl('',[Validators.max(95),Validators.min(40),Validators.required])

    public get model() {
        return this._device
    }

    public set model(v: Device) {
        this._device = v;
    }

    constructor(
        private _deviceService: DeviceService,
        private _dialog: MatDialog,
        private _toastService: ToasterService,
        private _companyService: CompanyService,
        private _translateService: TranslateService
    ) {
        super();
    }


    public async ngOnInit() {
        this.modelLoadParse();
        this.companyId = parseInt(localStorage.getItem("CompanyID"));
        try {
            this.deviceList = await this._deviceService.deviceContol();
        } catch (error) {
            console.warn(error);
        }

        if (parseInt(localStorage.getItem("CompanyID")) == 1) {
            try {
                this.companyList = await this._companyService.getCompanies();
            } catch (error) {
                console.warn(error);

            }
        }
        if (this.operation == "update") {
            this.selectedCompany = this.model.companyId;
        }
    }


    modelLoadParse(){
        this.model.msgStanby=this.model.msgStanby?((parseFloat(this.model.msgStanby)/1000).toString()):'0';
        this.model.batMin=this.model.batMin?((parseFloat(this.model.batMin)/100).toString()):'0';
        this.model.batGpMin=this.model.batGpMin?((parseFloat(this.model.batGpMin)/100).toString()):'0';
        this.model.heatAlarm=this.model.heatAlarm?((parseFloat(this.model.heatAlarm)/10).toString()):'0';
    }

    modelSetParse(){
        this.model.msgStanby=(parseFloat(this.model.msgStanby)*1000).toString();
        this.model.batMin=(parseFloat(this.model.batMin)*100).toString();
        this.model.batGpMin=(parseFloat(this.model.batGpMin)*100).toString();
        this.model.heatAlarm=(parseFloat(this.model.heatAlarm)*10).toString();

    }

    public async save() {
        this.modelSetParse()
        if (this.form.invalid
            || this.formPeriot.invalid
            || this.formShakeCount.invalid
            || this.formShakeWait.invalid
            || this.formDistanceTime.invalid
            || this.formDistanceValue.invalid
            || this.formSonicActive.invalid
            || this.formSonicFilter.invalid
            || this.formSonicTolerans.invalid
            || this.formSonicMeasure.invalid
            || this.formMessageRepeat.invalid
            || this.formMsgStanby.invalid
            || this.formRunType.invalid
            || this.formGpsRepeat.invalid
            || this.formGpsTime.invalid
            || this.formBatMin.invalid
            || this.formBatGpsMin.invalid
            || this.formBatMultiple.invalid
            || this.formSolarMultiple.invalid
            || this.formPeriotTimeOut.invalid
            || this.formHeatAlarm.invalid
            ) {
            this._toastService.toastWarning(
                this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY")
                );
                this.modelLoadParse();
            return;
        }
        var idControl = this.deviceList.findIndex(x=>x.id == this.model.id)
        if(idControl>=0 && this.operation == 'create'){
            this._toastService.toastWarning(
                this._translateService.instant("DEVICE_ID_UNIQ")
            );
            return;
        }

        this.model.status = true;
        this.model.updated = 1;
        this.model.empty1=(parseInt(this.model.empty1)+1).toString();
        this.model.companyId = parseInt(localStorage.getItem("CompanyID")) == 1 ? this.selectedCompany : parseInt(localStorage.getItem("CompanyID"))

        this.operation == "create"
            ? this.create()
            : this.update()
    }

    public async create() {
        try {
            this.model.time = new Date();
            await this._deviceService.add(this.model)
            this.added.emit(true)
        } catch (error) {
            console.warn(error);
            this.added.emit(false)
        }
    }

    public async update() {
        try {
            this.model.uDate = new Date();
            await this._deviceService.updated(this.model)
            this.updated.emit(true);
        } catch (error) {
            console.warn(error);
            this.updated.emit(false);
        }
    }

}



